// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"26213a28","150":"319270d6","182":"77418521","311":"15a1806c","312":"ff699681","332":"9fb987bc","705":"9f7f2aa0"}[chunkId] + ".chunk.js";
};